/// <reference types="./effects.d.mts" />
import * as $function from "../../gleam_stdlib/gleam/function.mjs";
import * as $effect from "../../lustre/lustre/effect.mjs";
import {
  toggleDomFreeze as do_toggle_dom_freeze,
  stopDomFreeze as do_stop_dom_freeze,
} from "../ds.ffi.mjs";
import * as $unsafe from "../ds/internals/unsafe.mjs";
import * as $window from "../web/browser/window.mjs";

export function subscribe_dom_click(on_unsubscriber, on_click) {
  return $effect.from(
    (dispatch) => {
      let unsubscriber = $unsafe.subscribe_dom_click(
        () => { return dispatch(on_click); },
      );
      return dispatch(on_unsubscriber(unsubscriber));
    },
  );
}

export function toggle_dom_freeze() {
  return $effect.from(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          return $window.request_animation_frame(
            (_) => { return do_toggle_dom_freeze(); },
          );
        },
      );
    },
  );
}

export function stop_dom_freeze() {
  return $effect.from((_) => { return do_stop_dom_freeze(); });
}
